<template>
  <div :class="['app-loader', `app-loader--${size}`]">
    <app-icon class="app-loader__icon" name="spinner" />
  </div>
</template>

<script>
  import AppIcon from '../AppIcon/AppIcon'

  export default {
    components: { AppIcon },
    props: {
      size: {
        type: String,
        validator: value => ['small', 'large'].indexOf(value) !== -1,
        default: 'small',
      },
    },
  }
</script>

<style lang="scss" src="./AppLoader.scss"></style>
